var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16.19 2.00195H7.81C4.17 2.00195 2 4.17195 2 7.81195V16.182C2 19.832 4.17 22.002 7.81 22.002H16.18C19.82 22.002 21.99 19.832 21.99 16.192V7.81195C22 4.17195 19.83 2.00195 16.19 2.00195Z",
    fill: "#009B62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5814 15.5816C10.3814 15.5816 10.1914 15.5016 10.0514 15.3616L7.22141 12.5316C6.93141 12.2416 6.93141 11.7616 7.22141 11.4716C7.51141 11.1816 7.99141 11.1816 8.28141 11.4716L10.5814 13.7716L15.7214 8.63156C16.0114 8.34156 16.4914 8.34156 16.7814 8.63156C17.0714 8.92156 17.0714 9.40156 16.7814 9.69156L11.1114 15.3616C10.9714 15.5016 10.7814 15.5816 10.5814 15.5816Z",
    fill: "#009B62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/done.36a97654c42e9dd68b0b400472a83c5d.svg";
export { ForwardRef as ReactComponent };